/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Authstartbody2Inputs */

const en_authstartbody2 = /** @type {(inputs: Authstartbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We'll email a one-click sign-in link to ${i?.email}. Once you're in, your diagnostic answers are already on your first case — no re-typing.`)
};

const pt_authstartbody2 = /** @type {(inputs: Authstartbody2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vamos enviar um link de acesso de um clique para ${i?.email}. Quando entrar, as suas respostas do diagnóstico já estão no primeiro caso — sem reescrever.`)
};

/**
* | output |
* | --- |
* | "We'll email a one-click sign-in link to {email}. Once you're in, your diagnostic answers are already on your first case — no re-typing." |
*
* @param {Authstartbody2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartbody2 = /** @type {((inputs: Authstartbody2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartbody2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartbody2(inputs)
	return pt_authstartbody2(inputs)
});
export { authstartbody2 as "authStartBody" }